let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6aSvJ")).then(() => parcelRequire('71H9N'));